const languageMap = {
  en: "English",
  hi: "Hindi",
  ta: "Tamil",
  te: "Telugu",
  ml: "Malayalam",
  kn: "Kannada",
  bn: "Bengali",
  mr: "Marathi",
  gu: "Gujarati",
  pa: "Punjabi",
  ur: "Urdu",
  fr: "French",
  es: "Spanish",
  ko: "Korean",
  ja: "Japanese",
  zh: "Chinese",
};

export default languageMap;
